import React from "react";
import "../../Styles/yellowcalf.css/Paid.css";

function Paid() {
  return (
    <div className="paid-container" style={{ paddingTop: "25px" }}>
      <div id="loader-div" className="paid-ajax-loader"></div>

      {/* First small panel */}
      <div className="paid-panel-first">
        <div className="paid-panel-first-title mb-3">Paid</div>
      </div>
      <div className="inv-filters d-flex  gap-3">
        <input
          type="text"
          className="inv-input"style={{ maxWidth: "200px" }}
          placeholder="Search Invoice No."
        />
        <select
          className="form-select "style={{ maxWidth: "200px" }}>
          <option value="">Select Payment Option</option>
          <option value="paypal">Paypal</option>
          <option value="bank">Bank</option>
          <option value="wire-transfer">Wire-transfer</option>
          <option value="cheque">Cheque</option>
          <option value="DD">DD</option>
          <option value="others">Others</option>
          <option value="by cash">By cash</option>
          <option value="payfort">Payfort</option>
          <option value="networkonline">Networkonline</option>
        </select>
       
          <button className="fw-clear-btn">Clear</button>
      </div>
      
      {/* Second panel with table */}
      <div className="paid-panel-second">
        <div className="paid-panel-second-heading" id="status-alert"></div>
        <div className="paid-table-container">
          <table className="paid-table">
            <thead>


              <tr>
                <th>Sr.No</th>
                <th>Invoice Number</th>
                <th>Payment Type</th>
                <th>Payment Mode</th>
                <th>Payment Status</th>
                <th>Payment Identification Number</th>
                <th>Amount</th>
                <th>Payment Date</th>
                <th>Invoice Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(5)].map((_, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>877</td>
                  <td>Service</td>
                  <td>Paytm</td>
                  <td>Paid</td>
                  <td>877_73554</td>
                  <td>$2700</td>
                  <td>Wed Apr 20 2022</td>
                  <td>Mon Jul 27 2020</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <a
                      className="paid-btn-green"
                      href="/accountant/payment/paymentReceipt"
                    >
                      <i class="bi bi-eye"></i>
                    </a>
                    <a
                      className="paid-btn-red"
                      href="/accountant/payment/Receipt_invoice"
                    >
                      <i class="bi bi-play-btn"></i>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="wallet-main-footer">
            <ul className="wallet-main-pagination">
              <li className="wallet-main-active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
            </ul>

            <div className="wallet-main-summary">
              Showing <b>1-50</b> of <b>177</b> items.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Paid;
